const TRANSITION_DELAY = 150;
const TRANSITION_DOWN_DURATION = 200;

export { TRANSITION_DELAY, TRANSITION_DOWN_DURATION };
